import { useEffect, useState } from "react";
import { getMeteoData } from "../api/meteo";

export const useGetMeteoRainDay = ({ meteoId, start, end }) => {
    const [observations, setObservations] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

  useEffect(() => {
    const fetchRainDay = async () => {
      try {
        const result = await getMeteoData({
          meteoId,
          start,
          end,
          parameter: "rainDay"
        });

        

        setObservations(result);
      } catch (error) {
        setError(error);
        console.error("Error al obtener lluvias diarias de la meteo:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchRainDay();
  }, [meteoId, start, end]);

  return { observations, loading, error };
};
